<template>
  <div>
    <v-client-table
      :data="tableItems"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
      :class="{'table-default--loading': tablePreloader}"
    >
      <template #h__id><div class="table-default__left">Contract</div></template>
      <template #h__main_seller><div class="table-default__left">Main seller</div></template>
      <template #h__second_seller><div class="table-default__left">Second seller</div></template>
      <template #h__created><div class="table-default__left">Created by</div></template>
      <template #h__updated><div class="table-default__left">Updated by</div></template>
      <template #id="{ row }">
        <div class="table-default__left">
          <router-link :to="{ name: 'land-purchase-contract-detail', params: { id: row.id } }" class="table-default__link-border">
            Contract - #{{ row.id }}
          </router-link>
        </div>
      </template>
      <template #main_seller="{ row }">
        <div class="table-default__left">{{ row.main_seller }}</div>
      </template>
      <template #second_seller="{ row }">
        <div class="table-default__left">{{ row.second_seller || '-' }}</div>
      </template>
      <template #village_fees_paid="{ row }">
        <app-checkbox
          v-if="!tablePreloader"
          @change.native="$emit('updateVillageFees', row)"
          v-model="row.village_fees_paid"
          class="checkbox--table"
        />
      </template>
      <template #created="{ row }">
        <div class="table-default__left">
          <div v-if="row.created_by" class="table-default__controls">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.created_by.crop.crop_url)" alt=""
                v-tooltip="{ content: row.created_by.full_name, placement: 'top-start', offset: 10 }"
              >
            </div>
            {{ dateTimeFormat(row.created_at) }}
          </div>
        </div>
      </template>
      <template #updated="{ row }">
        <div class="table-default__left">
          <div v-if="row.updated_by" class="table-default__controls">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.updated_by.crop.crop_url)" alt=""
                v-tooltip="{ content: row.updated_by.full_name, placement: 'top-start', offset: 10 }"
              >
            </div>
            {{ dateTimeFormat(row.updated_at) }}
          </div>
        </div>
      </template>
      <template #controls="{ row }">
        <div v-if="!row.confirmed" class="table-default__controls">
          <button @click="$emit('showDeleteModal', row.id)" type="button">
            <img src="@/assets/img/delete-table-icon.svg" alt="Delete">
          </button>
        </div>
      </template>
    </v-client-table>
    <app-cells position="between">
      <div>
        <paginate
          @input="$emit('clickPagination', $event)"
          v-if="pagination.pages > 1"
          v-model="pagination.page"
          :page-count="pagination.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
      </div>
      <app-table-records :all="pagination.count" :count="tableItems.length" :page="pagination.page" />
    </app-cells>
  </div>
</template>

<script>
import {format, parse, parseISO} from 'date-fns'

export default {
  name: 'TableLPC',
  props: ['tableItems', 'tablePreloader', 'pagination'],
  data() {
    return {
      table: {
        columns: ['id', 'main_seller', 'second_seller', 'village_fees_paid', 'created', 'updated', 'controls'],
        options: {
          headings: {
            id: 'Contract',
            main_seller: 'Main seller',
            second_seller: 'Second seller',
            village_fees_paid: 'Village fees paid',
            created: 'Created by',
            updated: 'Updated by',
            controls: '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  methods: {
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
  }
}
</script>
